"use strict";
/**
 * Helper class for making http request to logging endpoint
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestAdapter = exports.parsePayload = void 0;
var BEACON_MAX_SIZE = 50;
function parsePayload(logs) {
    return JSON.stringify(logs);
}
exports.parsePayload = parsePayload;
// sendBeacon has size limit of 64kb. Hence to avoid failing the request
// we are slicing the list with max 50 items
function request(url, logs) {
    if (logs.length <= BEACON_MAX_SIZE) {
        navigator.sendBeacon(url, parsePayload(logs));
        return;
    }
    // if the logs list is larger than expected send beacon size
    // then we split it into chunks to avoid failure
    var chunks = [];
    while (logs.length !== 0) {
        var chunkSize = logs.length < BEACON_MAX_SIZE ? logs.length : BEACON_MAX_SIZE;
        chunks.push(logs.splice(0, chunkSize));
    }
    chunks.forEach(function (chunk) { return navigator.sendBeacon(url, parsePayload(chunk)); });
}
function getRequestAdapter(url) {
    return function (logs) { return request(url, logs); };
}
exports.getRequestAdapter = getRequestAdapter;
//# sourceMappingURL=requestAdapter.js.map